import axios from "axios";

// Local: API separada na porta 5000. Produção: mesma origem em /api (sem CORS)
const baseURL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "/api";

export default axios.create({ baseURL });
export { baseURL };
